import Link from 'next/link'
import useEvent from '../../../lib/useEvent'
import useEventCrud from '../../../lib/useEventCrud'
import usePopoutTriggerRef from '../../../lib/usePopoutTriggerRef'
import useUser from '../../../lib/useUser'
import Icon from '../../common/Icon'
import {
  Popout,
  PopoutContent,
  PopoutTrigger,
} from '../../common/popout/Popout'
import PopoutButton from '../../common/popout/PopoutButton'
import { useAnalytics } from '../../context/AnalyticsProvider'
import { useTranslation } from '../../../lib/i18n'

const EventRSVP = ({ eventSlug, status }) => {
  const { popoutTriggerRef, popoutIsOpen } = usePopoutTriggerRef()
  const { event } = useEvent(popoutIsOpen ? eventSlug : null)
  const { user } = useUser()
  const { createEventAttendance, updateEventAttendance } = useEventCrud()
  const { trackData } = useAnalytics()
  const { t } = useTranslation()

  const submitAttendance = (response) => {
    if (status === 'going' || status === 'declined') {
      updateEventAttendance(user?.id, eventSlug, response)
    } else {
      createEventAttendance(user.id, eventSlug, response)
    }

    trackData('event_rsvp', {
      user,
      type: 'event',
      item: event,
      status: response,
    })
  }

  let statusButton = <RSVPButton color="bg-topic-blue" text={t('event.rsvp')} />
  switch (status?.toLowerCase()) {
    case 'going':
      statusButton = (
        <RSVPButton
          icon="check"
          color="bg-primary-20"
          text={t('event.going')}
        />
      )
      break
    case 'declined':
      statusButton = (
        <RSVPButton
          icon="times"
          color="bg-topic-pink"
          text={t('event.notGoing')}
        />
      )
      break
    default:
      statusButton = <RSVPButton color="bg-topic-blue" text={t('event.rsvp')} />
      break
  }

  if (!user) {
    return (
      <div className="bg-primary-20 text-white text-center px-1 py-1 rounded-3xl">
        <Link href="/login">{t('event.loginToRSVP')}</Link>
      </div>
    )
  }

  return (
    <Popout>
      <PopoutTrigger ref={popoutTriggerRef}>{statusButton}</PopoutTrigger>
      <PopoutContent>
        <PopoutButton onClick={() => submitAttendance('going')}>
          {t('event.going')}
        </PopoutButton>
        <PopoutButton onClick={() => submitAttendance('declined')}>
          {t('event.notGoing')}
        </PopoutButton>
      </PopoutContent>
    </Popout>
  )
}

export default EventRSVP

const RSVPButton = ({ icon, color, text }) => (
  <div
    className={`flex flex-row justify-center items-center p-1 ${color} rounded-lg line-clamp-2`}
  >
    {icon && <Icon name={icon} size={20} color="white" className="mr-2" />}
    <p className="text-white">{text}</p>
  </div>
)
